/**
 * Sugestiile pentru campurile de lot cu valori care se repeta, calculate de
 * API din toate loturile de deponent (`admin.depositors.contracts.lots.suggestions`).
 * Folosite de formularele de lot din contract si din licitatie.
 */
export interface LotSuggestions {
    type: string[];
    fabricOrTechnique: string[];
    dimensions: string[];
    technicalDetails: string[];
    restoration: string[];
}

export function emptyLotSuggestions(): LotSuggestions {
    return {
        type: [],
        fabricOrTechnique: [],
        dimensions: [],
        technicalDetails: [],
        restoration: [],
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/lot-suggestions.ts